import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _noop from "lodash/noop";
import _uniqueId from "lodash/uniqueId";
const _excluded = ["onSubmitAnswer"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { connect } from 'react-redux';
import hideCompletionPane from '../actions/actionCreators/hideCompletionPane';
import selectMultipleChoiceExerciseOption from '../actions/actionCreators/selectMultipleChoiceExerciseOption';
import showExercise from '../actions/actionCreators/showExercise';
import showHint from '../actions/actionCreators/showHint';
import MultipleChoiceExercise from '../components/MultipleChoiceExercise';
import mainApiClient from '../lib/mainApiClient';
import selectCompletionPaneVisible from '../selectors/selectCompletionPaneVisible';
import selectFeedbackMessagesForExercise from '../selectors/selectFeedbackMessagesForExercise';
import selectInteractionBlocked from '../selectors/selectInteractionBlocked';
import selectSelectedMultipleChoiceExerciseOption from '../selectors/selectSelectedMultipleChoiceExerciseOption';
import selectSuccessMessage from '../selectors/selectSuccessMessage';
import selectXpLost from '../selectors/selectXpLost';
const mapStateToProps = (state, _ref) => {
  let {
    environment,
    exercise,
    exerciseId
  } = _ref;
  return {
    completionPaneVisible: selectCompletionPaneVisible(state, exerciseId),
    feedbackMessages: selectFeedbackMessagesForExercise(state, exerciseId),
    interactionBlocked: selectInteractionBlocked(state, exerciseId),
    onRate: (() => {
      if (exercise === undefined) {
        return undefined;
      }
      const {
        externalId,
        isRatingPermitted
      } = exercise;
      if (!isRatingPermitted || externalId === null) {
        return undefined;
      }
      return payload => mainApiClient(environment).rateExercise(externalId, payload);
    })(),
    selectedOption: selectSelectedMultipleChoiceExerciseOption(state, exerciseId),
    successMessage: selectSuccessMessage(state, exerciseId),
    xpLost: selectXpLost(state, exerciseId)
  };
};
const mapDispatchToProps = (dispatch, _ref2) => {
  let {
    environment,
    exerciseId
  } = _ref2;
  return {
    hideCompletionPane: () => dispatch(hideCompletionPane(exerciseId)),
    onSelectOption: option => dispatch(selectMultipleChoiceExerciseOption(exerciseId, option)),
    onSubmitAnswer: (message, success) => dispatch({
      id: exerciseId,
      message,
      messageId: _uniqueId(),
      success,
      type: 'CHECK_EXERCISE_COMPLETED'
    }),
    showExercise: () => dispatch(showExercise(exerciseId)),
    showHint: _ref3 => {
      let {
        message,
        xpCost
      } = _ref3;
      return dispatch(showHint({
        environment,
        exerciseId,
        message,
        xpCost
      }));
    }
  };
};
const mergeProps = (stateProps, _ref4, ownProps) => {
  let {
      onSubmitAnswer
    } = _ref4,
    dispatchProps = _objectWithoutProperties(_ref4, _excluded);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, ownProps), stateProps), dispatchProps), {}, {
    onSubmitAnswer: onSubmitAnswer === undefined ? _noop : () => {
      const {
        selectedOption
      } = stateProps;
      const {
        exercise
      } = ownProps;
      if (selectedOption === undefined || exercise === undefined) {
        return;
      }
      const {
        feedbackMessage,
        isCorrect
      } =
      // @ts-expect-error TODO this should be looked into - likely a bug!
      exercise.possibleAnswers[selectedOption];
      onSubmitAnswer(feedbackMessage, isCorrect);
    }
  });
};
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(MultipleChoiceExercise);